module.exports = __webpack_public_path__ + "static/media/info.15ea3c6c.svg";